
/**
 * Tells if val is undefined or is of type "boolean".
 *
 * @param string 	val
 *
 * @return bool
 */
export default function(val) {
	return val === true || val === false;
};
